import React, { useEffect, useState } from "react";
import { MetaTags } from "react-meta-tags";
import { Button, Card, CardBody, Col, Container, Input, Row } from "reactstrap";
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import validator from 'validator';
import ReactInputMask from "react-input-mask";
import SelectList from "components/shared/select/select";


import Swal from "sweetalert2";
import api from "../../services/api";

const AcessoExterno = () => {



  const [initialValues, setInitialValues] = useState({
    id: null,
    nome: "",
    email: "",
    telefone: "",
    status: "A",
    senha: "",

  });
  const [modalCadastro, setModalCadastro] = useState(false);
  const toggleCadastro = () => setModalCadastro(!modalCadastro);
  const [modalSenha, setModalSenha] = useState(false);
  const toggleSenha = () => setModalSenha(!modalSenha);
  const [modalConfig, setModalConfig] = useState(false);
  const toggleConfig = () => setModalConfig(!modalConfig);
  const [modalType, setModalType] = useState("create");
  const [msgErro, setMsgErro] = useState("");
  const [values, setValues] = useState([]);
  const [kits, setKits] = useState([])
  const [kitsVinculados, setKitsVinculados] = useState([])
  const [adicionarKit, setAdicionarKit] = useState(0)
  const [senha, setSenha] = useState('')

  const [editValues, setEditValues] = useState(initialValues);

  const formatTelefone = (value) => {
    if (!value) return '';
    const cleaned = value.replace(/\D/g, '');
    if (cleaned.length < 11) {
      return cleaned.replace(/(\d{2})(\d{4})(\d{0,4})/, '($1)$2-$3');
    }
    return cleaned.replace(/(\d{2})(\d{5})(\d{0,4})/, '($1)$2-$3');
  }

  const formatValues = (data) => {
    let arr = [];
    data.map((val) => {
      arr.push({
        id: val.OID_EMPRESA_ACESSO,
        nome: val.DS_NOME,
        email: val.DS_EMAIL,
        localidade: val.DS_LOCALIDADE,
        telefone: val.NR_TELEFONE,
        status: val.TP_ATIVO,

      });
    });
    return arr;
  };
  const formatKits = (data) => {
    let arr = [];
    data.map((elem) => {
      arr.push({
        value: elem.OID_EQUIPAMENTO_DMAE,
        label: elem.NR_HIDROMETRO,
        NM_CONDOMINIO: elem.NM_CONDOMINIO,
        DS_LOCALIDADE: elem.DS_LOCALIDADE.indexOf('VINCULO COM SANEAMENTO') > -1 ? 'HD Não Cadastrado' : elem.DS_LOCALIDADE,
      });
    });
    return arr
  }
  const onSubmit = async () => {
    let err = ''
    let name = editValues.nome ? editValues.nome : '';
    let tel = editValues.telefone ? editValues.telefone?.replace(/\D/g, '') : '';
    let sen = editValues.senha ? editValues.senha : ''
    if (name.length == 0) {
      err = 'O nome não pode estar vazio';
    } else if (!validator.isEmail(editValues.email ?? 'invalido')) {
      err = 'Digite um E-mail válido';
    } else if (tel.length != 11 && tel.length != 12) {
      err = 'Telefone inválido'
    } else if (!editValues.id) {
      if (sen.length < 8) {
        err = 'Digite uma senha com no mínimo 8 digitos';
      }
    }

    if (err.length == 0) {
      let body = {
        OID_EMPRESA_ACESSO: editValues.id,
        DS_NOME: editValues.nome,
        DS_EMAIL: editValues.email,
        NR_TELEFONE: tel,
        TP_ATIVO: editValues.status
      }
      if (!editValues.id) {
        body.DS_SENHA = editValues.senha
      }

      await api.post("/externalacess/" + modalType, body).then((response) => {
        console.log(response.data.sucess);
        if (response.data.sucess) {
          getAcess();
          toggleCadastro();
          Swal.fire({
            icon: "sucess",
            text: response.data.msg,

          });
        } else {
          err = response.data.msg
        }

      });
    }
    setMsgErro(err);

  }
  const newPass = async () => {
    if (senha.length < 8) {
      setMsgErro('A senha precisa de no mínimo 8 caracteres');
      return
    }
    toggleSenha();
    Swal.fire({
      title: 'Essa ação é irreversível, deseja realmente alterar a senha?',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim',
      cancelButtonText: "Não"
    }).then((result) => {
      if (result.isConfirmed) {
        const body = {
          OID_EMPRESA_ACESSO: editValues.id,
          DS_SENHA: senha
        }

        api.post("/externalacess/changepass", body).then(
          (response) => {
            console.log(response.data.sucess);
            if (response.data.sucess) {
              Swal.fire({
                icon: "sucess",
                text: response.data.msg,

              });
              setSenha('');
            } else {
              setModalSenha(true);

              err = setMsgErro(response.data.msg)
            }

          })

      } else {
        setModalSenha(true);
        console.log('tá entrando...')
      }
    })
  }

  const addKit = () => {
    if (adicionarKit > 0) {
      const body = {
        OID_EMPRESA_ACESSO: editValues.id,
        OID_EQUIPAMENTO_DMAE: adicionarKit
      }
      api.post("/externalacess/addkit", body).then((response) => {
        if (response.data.sucess) {
          Swal.fire({
            icon: "success",
            text: response.data.msg,
          });
          getAcess();
          setAdicionarKit(0)
          listEquip(editValues.id)
        } else {
          Swal.fire({
            icon: "error",
            text: response.data.msg,
          });
        }
      })
    }
  }

  const deleteAccess = (dado) => {
    Swal.fire({
      title: 'Deseja realmente excluir este acesso?',
      text: "Esta ação é irreversível!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim',
      cancelButtonText: "Não"
    }).then((result) => {
      if (result.isConfirmed) {
        const body = {
          OID_EMPRESA_ACESSO: dado.id
        }

        api.post("/externalacess/delete", body).then(
          (response) => {
            if (response.data.sucess) {
              Swal.fire({
                icon: "success",
                text: response.data.msg,
              });
              getAcess();
            } else {
              Swal.fire({
                icon: "error",
                text: response.data.msg,
              });
            }
          })
      }
    })
  }

  const getAcess = () => {
    api.get("/externalacess").then((response) => {
      let arr = response.data;
      if (arr.length === 0) {
        setValues(initialValues);
      } else {
        setValues(formatValues(arr));
      }
    });
  }
  const listEquip = (id) => {
    let body = {
      OID_EMPRESA_ACESSO: id ? id : null
    }
    api.post("/externalacess/listequip", body).then((response) => {
      let arr = response.data;
      if (arr.length === 0) {
        id ? setKitsVinculados([]) : setKits([]);
      } else {
        id ? setKitsVinculados(formatKits(arr)) : setKits(formatKits(arr));

      }
    });
  }
  const removeKit = (id) => {
    const body = {
      OID_EQUIPAMENTO_DMAE: id
    }
    api.post("/externalacess/removekit", body).then((response) => {
      console.log(response.data.sucess);
      if (response.data.sucess) {
        Swal.fire({
          icon: "success",
          text: response.data.msg,
        });
        getAcess();
        listEquip(editValues.id)
      } else {
        Swal.fire({
          icon: "error",
          text: response.data.msg,
        });
      }
    })
  }



  useEffect(() => {
    getAcess();
    listEquip();
  }, []);





  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Acesso Externo</title>
        </MetaTags>
        <Container fluid>
          <div className="page-title-box">
            <Row className="align-items-center">
              <Col md={8}>
                <h6 className="page-title">Acesso Externo</h6>
                <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item active">
                    Bem vindo(a) ao IoT DMAE
                  </li>
                </ol>
              </Col>
            </Row>
          </div>
        </Container>

        <Row>
          <Col lg={12}>
            <Card>
              <CardBody>
                <div className="d-flex justify-content-start mb-1">
                  <Button
                    color="primary"
                    className="btn btn-primary waves-effect waves-light"
                    onClick={() => { setModalType("create"); setEditValues(initialValues); setMsgErro(); toggleCadastro() }}
                  >
                    Cadastrar Acesso
                  </Button>
                </div>
              </CardBody>

            </Card>
          </Col>
        </Row>

        <Container fluid>
          <div className="table-responsive">
            <table className="table align-middle table-nowrap mb-0 overflow-hidden">
              <thead className="table-light">
                <tr>
                  <th className="align-middle">Nome</th>
                  <th className="align-middle">Email</th>
                  <th className="align-middle">Localidade</th>
                  <th className="align-middle">Telefone</th>
                  <th className="align-middle">Status</th>
                  <th className="align-middle"> </th>
                </tr>
              </thead>
              <tbody>
                {values.length > 0 ? (
                  values?.map((dado, key) => (
                    <tr key={"_tr_" + key}>
                      <td>{dado.nome}</td>
                      <td>{dado.email}</td>
                      <td>{dado.localidade}</td>
                      <td>{formatTelefone(dado.telefone)}</td>
                      <td>{dado.status == 'A' ? 'ATIVO' : 'INATIVO'}</td>
                      <td>
                        <Button
                          type="button"

                          color="link"
                          size="sm"
                          className="btn-light waves-effect waves-light"
                          onClick={() => { setModalType("edit"); setMsgErro(); setEditValues(dado); toggleCadastro() }}
                        >
                          <i className="dripicons-document-edit" />
                        </Button>

                        <Button
                          type="button"

                          color="link"
                          size="sm"
                          className="btn-light waves-effect waves-light"
                          onClick={() => { setMsgErro(); listEquip(dado.id); setEditValues(dado); toggleConfig() }}
                        >
                          <i className="fas fa-user-cog" />
                        </Button>

                        <Button
                          type="button"

                          color="link"
                          size="sm"
                          className="btn-light waves-effect waves-light"
                          onClick={() => { setMsgErro(); setEditValues(dado); toggleSenha() }}
                        >
                          <i className="fas fa-key" />
                        </Button>

                        <Button
                          type="button"
                          onClick={() => deleteAccess(dado)}
                          color="link"
                          size="sm"
                          className="btn-light waves-effect waves-light"
                        >
                          <i className="dripicons-trash text-danger" />
                        </Button>
                      </td>

                    </tr>
                  ))
                ) : (
                  <><span className="text-center">Nenhuma empresa encontrada</span></>
                )}
              </tbody>
            </table>
          </div>

          <Modal isOpen={modalCadastro} toggle={toggleCadastro} className="w-50">
            <ModalHeader color="primary" toggle={toggleCadastro} className="d-flex justify-content-center page-title"><h2>{modalType == "create" ? "Cadastrar" : "Editar"}</h2></ModalHeader>
            <ModalBody>
              <Row className="mb-3">
                <h3 className="d-flex justify-content-center">Acesso Externo</h3>
                <div className="justify-content-center page-title">
                  <h4>Nome:</h4>
                  <input type="text" className="form-control" value={editValues.nome} onChange={(e) => setEditValues({ ...editValues, nome: e.target.value })} />
                  <h4>Email:</h4>
                  <input type="text" className="form-control" value={editValues.email} onChange={(e) => setEditValues({ ...editValues, email: e.target.value })} />
                  <h4>Telefone:</h4>
                  <ReactInputMask
                    mask="(99)99999-9999"
                    className="form-control"
                    type="text"
                    value={editValues.telefone}
                    onChange={(e) => { setEditValues({ ...editValues, telefone: e.target.value }) }}
                  />
                  {!editValues.id ? <>
                    <h4>Senha:</h4>
                    <input type="text" className="form-control" value={editValues.senha} onChange={(e) => setEditValues({ ...editValues, senha: e.target.value })} />
                  </> : <></>}
                  <h4>Status:</h4>
                  <select className="form-control" value={editValues.status} onChange={(e) => setEditValues({ ...editValues, status: e.target.value })}>
                    <option value="A">Ativo</option>
                    <option value="I">Inativo</option>
                  </select>
                  <br></br>
                  <span className="text-danger">{msgErro}</span>
                  <br></br><br />
                  <Button
                    color="primary"
                    className="btn btn-primary waves-effect waves-light d-flex justify-content-center mx-auto"
                    onClick={onSubmit}>
                    {modalType == "create" ? "Cadastrar" : "Editar"}
                  </Button>


                </div>


              </Row>
            </ModalBody>
            <ModalFooter>

            </ModalFooter>
          </Modal>

          <Modal isOpen={modalSenha} toggle={toggleSenha} className="w-50">
            <ModalHeader color="primary" toggle={toggleSenha} className="d-flex justify-content-center page-title"><h2>Alterar senha</h2></ModalHeader>
            <ModalBody>
              <Row className="mb-3">
                <h3 className="d-flex justify-content-center"></h3>
                <div className="justify-content-center page-title">
                  <h4>Nova senha para o usuário:<br></br> {editValues.nome}</h4>
                  <input type="text" className="form-control" value={senha} onChange={(e) => setSenha(e.target.value)} />
                  <br></br>
                  <span className="text-danger">{msgErro}</span>
                  <br></br><br />
                  <Button
                    color="primary"
                    className="btn btn-primary waves-effect waves-light d-flex justify-content-center mx-auto"
                    onClick={newPass}>
                    Confirmar Alteração
                  </Button>


                </div>


              </Row>
            </ModalBody>
            <ModalFooter>

            </ModalFooter>
          </Modal>


          <Modal isOpen={modalConfig} toggle={toggleConfig} size="lg">
            <ModalHeader color="primary" toggle={toggleConfig} className="d-flex justify-content-center page-title"><h2>Configurar acessos de:</h2></ModalHeader>
            <ModalBody>
              <Row className="mb-3">
                <h3 className="d-flex justify-content-center"></h3>
                <div className="justify-content-center page-title">
                  <h4> {editValues.nome}</h4>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <div className="w-75">
                      <SelectList
                        id="kits"
                        options={kits}
                        pHolder='Selecione o hidrômetro'
                        onOptionSelect={(handleOptionSelect) => {
                          setAdicionarKit(handleOptionSelect)
                          console.log(handleOptionSelect)
                        }}
                      />
                    </div> <Button
                      color="primary"
                      className="btn btn-primary waves-effect waves-light d-flex justify-content-center mx-auto"
                      onClick={addKit}>
                      +
                    </Button>
                  </div>
                  <br></br>
                  <span className="text-danger">{msgErro}</span>
                  <br></br><br></br>

                  {kitsVinculados.length == 0 ?

                    <>
                      <span>Nenhum equipamento foi vinculado a este usuário</span>
                    </> : <>
                      <div className="table-responsive">
                        <table className="table align-middle table-nowrap mb-0 overflow-hidden">
                          <thead className="table-light">
                            <tr>
                              <th className="align-middle">Hidrômetro</th>
                              <th className="align-middle">Nome do Condomínio</th>
                              <th className="align-middle">Localidade</th>
                              <th className="align-middle"> </th>
                            </tr>
                          </thead>
                          <tbody>
                            {kitsVinculados?.map((dado, key) => (
                              <tr key={"_tr_" + key}>
                                <td>{dado.label}</td>
                                <td>{dado.NM_CONDOMINIO}</td>
                                <td>{dado.DS_LOCALIDADE}</td>
                                <td className="align-">

                                  <Button
                                    type="button"
                                    onClick={() => { removeKit(dado.value) }}
                                    color="link"
                                    size="sm"
                                    className="btn-light waves-effect waves-light"
                                  >
                                    <i className="dripicons-trash text-danger" />
                                  </Button>
                                </td>

                              </tr>
                            ))
                            }
                          </tbody>
                        </table>
                      </div>
                    </>}





                </div>


              </Row>
            </ModalBody>
            <ModalFooter>

            </ModalFooter>
          </Modal>


        </Container>
      </div>
    </React.Fragment>
  );
};

export default AcessoExterno;
